import { number, shape, string } from 'prop-types';

export default shape({
  id: number,
  avatar_url: string,
  brand: string,
  external_id: string,
  external_name: string,
  name: string,
  platform_display: string,
  platform_key: string,
  profile_link: string,
  screen_name: string,
  status: string,
  type: string,
  type_display: string,
  type_key: string,
});
